export default __webpack_public_path__ + "static/d11-20df58ced924f87a97309f46de1e8726.png";